module.exports = __webpack_public_path__ + "img/bebidas.e94ea69a.png";